var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips-wrap"},[_c('el-checkbox',_vm._g(_vm._b({staticClass:"checkbox-custom"},'el-checkbox',_vm.$attrs,false),_vm.$listeners)),_c('div',{staticClass:"tips-text"},[_vm._v(_vm._s(_vm.$t('login.register.subscribe')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }